import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';
import { CheckboxRadioItem } from '@work4all/components/lib/input/checkbox-radio-item';

import { useErpPositionsAutomaticNumberingContext } from '../../../erp/contexts/ErpPositionsAutomaticNumberingContext';

export const AutomaticNumbering = () => {
  const { t } = useTranslation();

  const { isUserAutomaticNumberingEnabled, toggleUserAutomaticNumbering } =
    useErpPositionsAutomaticNumberingContext();

  return (
    <Collapse
      title={t('SETTINGS.TABLES.AUTOMATIC_POSITION_NUMBERING')}
      defaultOpen
    >
      <CheckboxRadioItem
        label={t(
          'SETTINGS.TABLES.AUTOMATIC_POSITION_NUMBERING.IN_NEW_DOCUMENTS'
        )}
        checked={isUserAutomaticNumberingEnabled}
        onChange={toggleUserAutomaticNumbering}
      />
    </Collapse>
  );
};
